import React from 'react';
import { Modal } from 'antd';
import './style/alert.scss';

const confirmProps = {
  cancelText: 'cancel',
  okText: 'delete',
  content: 'Do you confirm to delete this item?',
  cancelButtonProps: {
    className: 'cancel-btn',
  },
  maskClosable: true,
};
const customConfirm = (
  customContent,
  customOK = 'delete',
  customCancel = 'cancel',
) => ({
  cancelText: customCancel,
  okText: customOK,
  content: customContent,
  cancelButtonProps: {
    className: 'cancel-btn',
  },
  maskClosable: true,
});
const confirmWithSaveProps = {
  className: 'alert-warning-save',
  content: 'Please save your changes before you leaving the page.',
  okText: 'save',
};
const confirmNotSaveProps = {
  className: 'alert-warning-save',
  content: 'Do you want to cancel all the changes?',
  okText: 'yes',
};
const alertBox = (content, type) => {
  if (content.className) {
    content.customizedClassName = content.className;
    delete content.className;
  }
  if (typeof content === 'string') {
    content = { content };
  }
  if (type === 'confirmWithSave') {
    content = { ...confirmWithSaveProps, ...content };
  }
  if (type === 'confirmWithNoSave') {
    content = { ...confirmNotSaveProps, ...content };
  }
  if (type === 'confirm') {
    content = { ...confirmProps, ...content };
  }
  if (type === 'customConfirm') {
    content = {
      ...customConfirm(
        content.customContent,
        content.customOK,
        content.customCancel,
      ),
      ...content,
    };
  }

  if (content.className || content.customizedClassName) {
    content.className = `alert-box ${content.className || ''} ${
      content.customizedClassName || ''
    }`;
  }

  const typeClass = type === 'error' ? 'alert-error-wrapper' : '';

  return Modal[
    type === 'confirmWithSave' ||
    type === 'confirmWithNoSave' ||
    type === 'customConfirm'
      ? 'confirm'
      : type
  ]({
    closable: true,
    icon: (
      <span
        className={`${
          type === 'confirm' ||
          type === 'confirmWithSave' ||
          type === 'confirmWithNoSave' ||
          type === 'customConfirm'
            ? 'warning'
            : type
        }-badge`}
      >
        {type === 'error' ? 'ERROR' : type === 'success' ? '' : 'WARNING'}
      </span>
    ),
    className: `alert-box ${content.async ? 'async' : ''} ${
      content.noCloseIcon ? 'no-close-icon' : ''
    } ${typeClass}`, // ADD typeClass here
    okText: 'Ok',
    ...content,
  });
};

const lastErrorShownAt = new Map();
const ERROR_DEDUP_MS = 600;

function alertBoxWithErrorDedupe(content, type) {
  if (type !== 'error') {
    return alertBox(content, type);
  }
  const key =
    typeof content === 'string'
      ? content
      : String(content?.content ?? JSON.stringify(content ?? {}));
  const now = Date.now();
  const prev = lastErrorShownAt.get(key) || 0;
  if (now - prev < ERROR_DEDUP_MS) {
    return undefined;
  }
  lastErrorShownAt.set(key, now);
  return alertBox(content, type);
}

export default alertBoxWithErrorDedupe;
